import {Component, inject, Renderer2, signal} from '@angular/core';
import {SecurityService} from "../../../security/security.service";
import {RouterLink} from "@angular/router";
import {notImplementedYet} from "../../../app.constants";

@Component({
  selector: 'app-portal',
  standalone: true,
  imports: [
    RouterLink
  ],
  templateUrl: './portal.component.html',
  styleUrl: './portal.component.scss'
})
export class PortalComponent {
  principalName?: string;
  renderer = inject(Renderer2);
  toggleSidebar = signal(true);
  authenService = inject(SecurityService);

  ngOnInit(): void {
    this.authenService.user$()
      .subscribe((value: any) => {
        this.principalName = value?.name;
      });
  }

  sidebarToggle() {
    this.toggleSidebar.set(!this.toggleSidebar());
  }

  setFontSizeTo(fontSize: string) {
    this.renderer.setAttribute(document.querySelector('body'), 'data-default-font-size', fontSize);
    document.querySelectorAll('[id^=defaultFontSize]')
      .forEach((value, key) => {
        if (value.id.endsWith(fontSize)) {
          this.renderer.addClass(value, 'active');
        } else {
          this.renderer.removeClass(value, 'active');
        }
      });
  }

  protected readonly notImplementedYet = notImplementedYet;
}
